import React, { createContext, useContext, useState } from "react";
import Toast from "../Toast/Toast";

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const showToast = (
    message,
    type = "info",
    duration = 3000,
    position = "topRight"
  ) => {
    const id = Date.now();
    setToasts((prevToasts) => [
      ...prevToasts,
      { id, message, type, duration, position },
    ]);

    return id;
  };

  const hideToast = (id) => {
    setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
  };

  // Convenience methods for different toast types
  const success = (message, duration, position) =>
    showToast(message, "success", duration, position);

  const info = (message, duration, position) =>
    showToast(message, "info", duration, position);

  const warning = (message, duration, position) =>
    showToast(message, "warning", duration, position);

  const error = (message, duration, position) =>
    showToast(message, "error", duration, position);

  return (
    <ToastContext.Provider
      value={{ showToast, hideToast, success, info, warning, error }}
    >
      {children}
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          message={toast.message}
          type={toast.type}
          duration={toast.duration}
          position={toast.position}
          onClose={() => hideToast(toast.id)}
        />
      ))}
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToast must be used within a ToastProvider");
  }
  return context;
};
